import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams, useParams } from 'react-router-dom';
import Image from '../../../src/assets/images/Imperative_Logo.png';
import axios from 'axios';

const totalSteps = 5;

const initialState = {
  // Token
  onboarding_token: '',
  
  // Page 1
  // employee_id: '',
  // is_bfl_employee: '',
  email: '',
  full_name: '',
  contact_number: '',
  date_of_birth: '',
  date_of_joining: '',
  designation: '',
  
  current_address: '',
  permanent_address: '',
  sameAsPermanent: false,

  emergency_contact_1: '',
  emergency_name_1: '',
  emergency_relation_1: '',

  emergency_contact_2: '',
  emergency_name_2: '',
  emergency_relation_2: '',

  blood_group: '',
  updated_cv: null,
  passport_photo: null,
  aadhar_card: null,
  aadhar_number: '',
  pan_card: null,
  pan_number: '',
  account_number: '',
  confirm_account_number: '',
  ifsc_code: '',

  // Page 2
  highest_qualification: '',
  year_of_passing: '',
  education_level: '',
  marksheet_10th: null,
  marksheet_12th: null,
  graduate_marksheet: null,
  postgraduate_marksheet: null,
  phd_marksheet: null,
  other_qualifications: null,
  leaving_certificate: null,

  // Page 3
  bank_proof: null,
  uan_number: '',
  esic_number: '',
  // signed_offer_letter: null,
  employee_type: '',
  
  // Page 4 (Full Time only)
  previous_offer_letter: null,
  experience_letter: null,
  salary_slip_1: null,
  salary_slip_2: null,
  salary_slip_3: null,

  previous_company_name: '',
  prev_emp_id: '',
  prev_designation: '',
  prev_hr_name: '',
  prev_hr_email: '',
  prev_hr_contact: '',

  // page 5 (Organizational Documents)
  // nda: '',
  // self_declaration: '',
  // concern_form: '',
  // code_of_conduct: '',
  // background_verification: '',
  // induction_acknowledgment: '',
  // infosec_acknowledgment: '',
  // posh_acknowledgment: '',
  
  // Page 5
  followed_ibvl_social: '',
  feedback: '',
  rating: 0,
};

const EmployeeOnboardingForm = () => {
  const [searchParams] = useSearchParams();
  const { token: tokenFromPath } = useParams();
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState(initialState);
  const [formErrors, setFormErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showClearModal, setShowClearModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSummaryModal, setShowSummaryModal] = useState(false); // New state for summary modal
  const urlTokenProcessed = useRef(false); // Track if URL token has been processed
  
  // Token validation state
  const [tokenValidationStatus, setTokenValidationStatus] = useState('idle'); // 'idle' | 'validating' | 'valid' | 'error'
  const [tokenErrorMessage, setTokenErrorMessage] = useState('');
  const [isTokenValid, setIsTokenValid] = useState(false);

  const [fileInputKeys, setFileInputKeys] = useState({
    updated_cv: Date.now(),
    passport_photo: Date.now() + 1,
    aadhar_card: Date.now() + 2,
    pan_card: Date.now() + 3,

    marksheet_10th: Date.now() + 4,
    marksheet_12th: Date.now() + 5,
    graduate_marksheet: Date.now() + 6,
    phd_marksheet: Date.now() + 7,
    other_qualifications: Date.now() + 8,
    leaving_certificate: Date.now() + 9,

    bank_proof: Date.now() + 10,
    // signed_offer_letter: Date.now() + 11,

    previous_offer_letter: Date.now() + 11,
    experience_letter: Date.now() + 12,
    salary_slip_1: Date.now() + 13,
    salary_slip_2: Date.now() + 14,
    salary_slip_3: Date.now() + 15,
    postgraduate_marksheet:Date.now() + 16,

    // nda: Date.now() + 18,
    // self_declaration: Date.now() + 19,
    // concern_form: Date.now() + 20,
    // code_of_conduct: Date.now() + 21,
    // background_verification: Date.now() + 22,
    // induction_acknowledgment: Date.now() + 23,
    // infosec_acknowledgment: Date.now() + 24,
    // posh_acknowledgment: Date.now() + 25,
  });
  
  // const resetFileInputKey = (fieldName) => {
  //   setFileInputKeys((prev) => ({
  //     ...prev,
  //     [fieldName]: Date.now(),
  //   }));
  // };

  function formatAadharForDisplay(aadharNumber) {
    // Format the digits with hyphens (XXXX-XXXX-XXXX)
    const digits = aadharNumber || '';
    let formattedValue = '';
    
    if (digits.length > 0) {
      // First group (up to 4 digits)
      formattedValue = digits.substring(0, 4);
      
      // Second group (4-8 digits)
      if (digits.length > 4) {
        formattedValue += '-' + digits.substring(4, 8);
      }
      
      // Third group (8-12 digits)
      if (digits.length > 8) {
        formattedValue += '-' + digits.substring(8, 12);
      }
    }
    
    return formattedValue;
  }

  // Validate onboarding token with a specific token value
  const validateOnboardingTokenWithToken = async (tokenToValidate) => {
    const token = tokenToValidate?.trim();
    
    if (!token) {
      setTokenValidationStatus('idle');
      setTokenErrorMessage('');
      setIsTokenValid(false);
      return;
    }

    // Prevent duplicate validation calls
    if (tokenValidationStatus === 'validating') {
      return;
    }

    setTokenValidationStatus('validating');
    setTokenErrorMessage('');
    setIsTokenValid(false);

    try {
      const response = await axios.post(
        'https://hrmspayroll.prepstripe.com/api/onboarding-form/validate-token',
        { onboarding_token: token },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200 && response.data.valid) {
        setTokenValidationStatus('valid');
        setTokenErrorMessage('');
        setIsTokenValid(true);

        // Pre-fill candidate data from response
        if (response.data.candidate) {
          setFormData((prevData) => ({
            ...prevData,
            full_name: response.data.candidate.name || prevData.full_name,
            email: response.data.candidate.email || prevData.email,
            contact_number: response.data.candidate.contact_no || prevData.contact_number,
          }));
        }
      } else {
        setTokenValidationStatus('error');
        setTokenErrorMessage(response.data.message || 'Token validation failed');
        setIsTokenValid(false);
      }
    } catch (error) {
      setTokenValidationStatus('error');
      
      if (error.response) {
        // Handle 404, 422, etc.
        const errorMessage = error.response.data?.message || 'Token validation failed';
        setTokenErrorMessage(errorMessage);
      } else if (error.request) {
        // Network error
        setTokenErrorMessage('Network error. Please check your connection and try again.');
      } else {
        // Other error
        setTokenErrorMessage('An unexpected error occurred. Please try again.');
      }
      
      setIsTokenValid(false);
    }
  };

  // Validate onboarding token (uses current formData token)
  const validateOnboardingToken = async () => {
    await validateOnboardingTokenWithToken(formData.onboarding_token);
  };

  // Extract token from URL params (path or query) on mount and auto-validate
  useEffect(() => {
    // Priority: path parameter > query parameter
    const token = tokenFromPath || searchParams.get('token');
    
    // Debug: Log token extraction
    console.log('Token extraction:', { tokenFromPath, queryToken: searchParams.get('token'), finalToken: token });
    
    if (token && !urlTokenProcessed.current) {
      urlTokenProcessed.current = true;
      setFormData((prevData) => ({
        ...prevData,
        onboarding_token: token,
      }));
      // Auto-validate token from URL
      validateOnboardingTokenWithToken(token);
    } else if (!token && !urlTokenProcessed.current) {
      // Mark as processed but don't show error - allow manual entry
      urlTokenProcessed.current = true;
    }
  }, [tokenFromPath, searchParams]);

  useEffect(() => {
    if (formData.employee_type === "Fresher") {
      setFormData((prevData) => ({
        ...prevData,
        previous_offer_letter: "",
        experience_letter: "",
        salary_slip_1: "",
        salary_slip_2: "",
        salary_slip_3: "",
      }));
    }
  }, [formData.employee_type]);

  // New function to generate summary
  const generateSummary = () => {
    const summaryFields = {
      // { label: 'Employee ID', value: formData.employee_id },
        // { label: 'Is BFL Employee', value: formData.is_bfl_employee },
      // Page 1 fields
      'Personal Details': [
        { label: 'Email', value: formData.email },
        { label: 'Full Name', value: formData.full_name },
        { label: 'Contact Number', value: formData.contact_number },
        { label: 'Date of Birth', value: formData.date_of_birth },
        { label: 'Date of Joining', value: formData.date_of_joining },
        { label: 'Designation', value: formData.designation },
        { label: 'Permanent Address', value: formData.permanent_address },
        { label: 'Current Address', value: formData.current_address },
        { label: 'Blood Group', value: formData.blood_group },
      ],
      'Emergency Contacts': [
        { label: 'Emergency Contact 1', value: formData.emergency_contact_1 },
        { label: 'Emergency Name 1', value: formData.emergency_name_1 },
        { label: 'Emergency Relation 1', value: formData.emergency_relation_1 },
        { label: 'Emergency Contact 2', value: formData.emergency_contact_2 },
        { label: 'Emergency Name 2', value: formData.emergency_name_2 },
        { label: 'Emergency Relation 2', value: formData.emergency_relation_2 },
      ],
      'Documents': [
        { label: 'CV', value: formData.updated_cv?.name },
        { label: 'Passport Photo', value: formData.passport_photo?.name },
        { label: 'Aadhar Card', value: formData.aadhar_card?.name },
        { label: 'Aadhar Card Number', value: formData.aadhar_number },
        { label: 'PAN Card', value: formData.pan_card?.name },
        { label: 'PAN Card Number', value: formData.pan_number },
        { label: 'IFSC Code', value: formData.ifsc_code },
        { label: 'Account Number', value: formData.account_number },
        { label: 'Confirmed Account Number', value: formData.confirm_account_number },
      ],
      'Educational Details': [
        { label: 'Highest Qualification', value: formData.highest_qualification },
        { label: 'Year of Passing', value: formData.year_of_passing },
        { label: 'Education Level', value: formData.education_level },
        { label: '10th Marksheet', value: formData.marksheet_10th?.name },
        { label: '12th Marksheet', value: formData.marksheet_12th?.name },
        { label: 'Graduate Marksheet', value: formData.graduate_marksheet?.name },
        { label: 'Postgraduate Marksheet', value: formData.postgraduate_marksheet?.name },
        { label: 'Ph.D Marksheet', value: formData.phd_marksheet?.name },
        { label: 'Other Qualifications', value: formData.other_qualifications?.name },
        { label: 'Leaving Certificate', value: formData.leaving_certificate?.name },
      ],
      'Employment Details': [
        { label: 'Bank Proof', value: formData.bank_proof?.name },
        { label: 'UAN Number', value: formData.uan_number },
        { label: 'ESIC Number', value: formData.esic_number },
        { label: 'Employee Type', value: formData.employee_type },
      ],
      // 'BFL Documents': [
      //   { label: 'NDA', value: formData.nda?.name },
      //   { label: 'Experience Letter', value: formData.self_declaration?.name },
      //   { label: 'Concern Form', value: formData.concern_form?.name },
      //   { label: 'Code of Conduct', value: formData.code_of_conduct?.name },
      //   { label: 'Background verification', value: formData.background_verification?.name },
      //   { label: 'Induction Acknowledgment', value: formData.induction_acknowledgment?.name },
      //   { label: 'Infosec Acknowledgment', value: formData.infosec_acknowledgment?.name },
      //   { label: 'Posh Acknowledgment', value: formData.posh_acknowledgment?.name },
      // ],
      'Final Feedback': [
        { label: 'Followed IBVL Social', value: formData.followed_ibvl_social },
        { label: 'Feedback', value: formData.feedback },
        { label: 'Rating', value: formData.rating },
      ]
    };


    // Insert "Previous Employment" after "Employment Details"
    if (formData.employee_type === 'Experienced') {
      const reordered = {};
      for (const key of Object.keys(summaryFields)) {
        reordered[key] = summaryFields[key];
        if (key === 'Employment Details') {
          reordered['Previous Employment'] = [
            { label: 'Previous Offer Letter', value: formData.previous_offer_letter?.name },
            { label: 'Experience Letter', value: formData.experience_letter?.name },
            { label: 'Salary Slip 1', value: formData.salary_slip_1?.name },
            { label: 'Salary Slip 2', value: formData.salary_slip_2?.name },
            { label: 'Salary Slip 3', value: formData.salary_slip_3?.name },
            { label: 'Previous Company Name', value: formData.previous_company_name},
            { label: 'Employee ID', value: formData.prev_emp_id},
            { label: 'Designation', value: formData.prev_designation},
            { label: 'HR Name', value: formData.prev_hr_name},
            { label: 'HR Email', value: formData.prev_hr_email},
            { label: 'HR Contact', value: formData.prev_hr_contact},
          ];
        }
      }
      return reordered;
    }

    return summaryFields;
  };

  // Render summary modal
  const renderSummaryModal = () => {
    const summary = generateSummary();

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end md:items-center z-[1001] backdrop-blur-sm">
        <div className="bg-white overflow-auto h-[600px] rounded-t-lg md:rounded-lg shadow-xl p-6 w-full md:w-[800px] mx-auto relative transition-transform duration-300 transform md:animate-none animate-slideUp">
          <h2 className="md:text-2xl text-lg font-semibold mb-4 text-center">Form Summary</h2>
          {Object.entries(summary).map(([section, fields]) => (
            <div key={section} className="mb-6">
              <h3 className="md:text-xl text-md font-bold border-b pb-2 mb-3">{section}</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {fields.map((field, index) => (
                  field.value && (
                    <div key={index} className="bg-gray-100 p-3 rounded">
                      <span className="font-semibold text-gray-700 block mb-1">{field.label}:</span>
                      <span className="text-gray-900">
                        {field.value instanceof File 
                          ? field.value.name 
                          : (field.value === true || field.value === false 
                              ? (field.value ? 'Yes' : 'No') 
                              : field.value)}
                      </span>
                    </div>
                  )
                ))}
              </div>
            </div>
          ))}
          <div className="flex justify-center mt-6">
            <button
              className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
              onClick={() => setShowSummaryModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };
  
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const processedValue = name === "ifsc_code" || name === "pan_number" ? value.toUpperCase() : value

    const updatedFormData = {
      ...formData,
      [name]: processedValue,
    };

    let updatedErrors = { ...formErrors };

    // Reset current field error
    updatedErrors[name] = "";

    // Character length validations
    if (name === "full_name" && value.length > 50) {
      updatedErrors[name] = "Full Name must not exceed 50 characters.";
    }

    if (name === "designation" && value.length > 50) {
      updatedErrors[name] = "Designation must not exceed 50 characters.";
    }

    if (name === "permanent_address" && value.length > 200) {
      updatedErrors[name] = "Permanent Address must not exceed 200 characters.";
    }

    if (name === "current_address" && value.length > 200) {
      updatedErrors[name] = "Current Address must not exceed 200 characters.";
    }

    if (name === "blood_group" && value.length > 5) {
      updatedErrors[name] = "Blood Group must not exceed 5 characters.";
    }

    if (name === "emergency_name_1" && value.length > 50) {
      updatedErrors[name] = "Emergency Name 1 must not exceed 50 characters.";
    }

    if (name === "emergency_relation_1" && value.length > 30) {
      updatedErrors[name] = "Emergency Relation 1 must not exceed 30 characters.";
    }

    if (name === "emergency_name_2" && value.length > 50) {
      updatedErrors[name] = "Emergency Name 2 must not exceed 50 characters.";
    }

    if (name === "emergency_relation_2" && value.length > 30) {
      updatedErrors[name] = "Emergency Relation 2 must not exceed 30 characters.";
    }

    // Numeric-only validations with max length
    if (name === "contact_number") {
      if (value.length > 10) {
        updatedErrors[name] = "Contact Number must not exceed 10 digits.";
      } else if (value && !/^\d*$/.test(value)) {
        updatedErrors[name] = "Contact Number must contain only numbers.";
      }
    }

    if (name === "emergency_contact_1") {
      if (value.length > 10) {
        updatedErrors[name] = "Emergency Contact 1 must not exceed 10 digits.";
      } else if (value && !/^\d*$/.test(value)) {
        updatedErrors[name] = "Emergency Contact 1 must contain only numbers.";
      }
    }

    if (name === "emergency_contact_2") {
      if (value.length > 10) {
        updatedErrors[name] = "Emergency Contact 2 must not exceed 10 digits.";
      } else if (value && !/^\d*$/.test(value)) {
        updatedErrors[name] = "Emergency Contact 2 must contain only numbers.";
      }
    }

    // Validation: Emergency contact ≠ personal contact number
    if (
      (name === "emergency_contact_1" || name === "emergency_contact_2") &&
      value === formData.contact_number
    ) {
      updatedErrors[name] = "Emergency number cannot be the same as your contact number";
    }

    // Validation: emergency_contact_1 ≠ emergency_contact_2
    if (name === "emergency_contact_1" && value === formData.emergency_contact_2) {
      updatedErrors[name] = "Emergency contact 1 cannot be the same as emergency contact 2";
    }

    if (name === "emergency_contact_2" && value === formData.emergency_contact_1) {
      updatedErrors[name] = "Emergency contact 2 cannot be the same as emergency contact 1";
    }

    // Validation: account number match
    if (
      (name === "account_number" && formData.confirm_account_number && value !== formData.confirm_account_number) ||
      (name === "confirm_account_number" && formData.account_number && value !== formData.account_number)
    ) {
      updatedErrors.confirm_account_number = "Account number and confirm account number must match.";
    } else if (name === "account_number" || name === "confirm_account_number") {
      updatedErrors.confirm_account_number = "";
    }

    // Apply changes
    setFormData(updatedFormData);
    setFormErrors(updatedErrors);
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
  
    if (!files.length) return;
  
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ];
  
    if (name === "salary_slips") {
      const selectedFiles = Array.from(files).slice(0, 3); // Allow max 3 files
  
      for (let file of selectedFiles) {
        if (!allowedTypes.includes(file.type)) {
          alert(`Invalid file type for ${file.name}. Only PDF, JPEG, JPG, PNG are allowed.`);
          return;
        }
  
        if (file.size > 2 * 1024 * 1024) {
          alert(`File ${file.name} exceeds the 2 MB size limit.`);
          return;
        }
      }
  
      setFormData((prev) => ({
        ...prev,
        [name]: selectedFiles,
      }));
    } else {
      const file = files[0];
  
      if (!allowedTypes.includes(file.type)) {
        alert('Invalid file type. Only PDF, JPEG, JPG, PNG are allowed.');
        return;
      }
  
      if (file.size > 2 * 1024 * 1024) {
        alert('File size should not exceed 2 MB.');
        return;
      }
  
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
    }
  };
  
  const allowedTypes = [
    'application/pdf',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ];
  
  const validateStep1 = () => {
    const errors = {};
    const requiredFields = [
      // 'is_bfl_employee', 
      // 'employee_id', 
      'email', 
      'full_name', 
      'contact_number', 
      'date_of_birth',
      'date_of_joining', 
      'designation',
      'permanent_address', 
      'current_address', 
      'emergency_contact_1',
      'emergency_name_1', 
      'emergency_relation_1', 
      'emergency_name_2', 
      'emergency_contact_2', 
      'emergency_relation_2', 
      'blood_group',
      'aadhar_number', 
      'pan_number', 
      'ifsc_code', 
      'account_number',
      'confirm_account_number'
    ];
    const requiredFiles = ['updated_cv', 'passport_photo', 'aadhar_card', 'pan_card'];
  
    requiredFields.forEach(field => {
      if (!formData[field]?.trim()) errors[field] = 'This field is required.';
    });

    // Employee ID validation: should be exactly 5 digits
    const employee_id = String(formData.employee_id || '');
    const employeeIdRegex = /^\d{5}$/;
    if (employee_id && !employeeIdRegex.test(employee_id)) {
        errors.employee_id = 'Employee ID should be exactly 5 digits.';
    }

    // Aadhar Number validation: should be exactly 12 digits
    const aadhar_number = String(formData.aadhar_number || '');
    if (aadhar_number && !/^\d{12}$/.test(aadhar_number)) {
      errors.aadhar_number = 'Aadhar Number must be exactly 12 digits.';
    }

    const full_name = String(formData.full_name || '');
    if (full_name && /[0-9]/.test(full_name)) {
      errors.full_name = 'Full Name should not contain numbers.';
    }
    if (full_name && full_name.length > 50) {
      errors.full_name = 'Full Name must not exceed 50 characters.';
    }

    const date_of_birth = String(formData.date_of_birth || '');
    if (date_of_birth && !/^\d{4}-\d{2}-\d{2}$/.test(date_of_birth)) {
      errors.date_of_birth = 'Date of birth should be in the format YYYY-MM-DD.';
    } else if (date_of_birth) {
      // Age validation - must be at least 18 years old
      const birthDate = new Date(date_of_birth);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      
      // Check if birthday has occurred this year
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      
      if (age < 18) {
        errors.date_of_birth = 'You must be at least 18 years old.';
      }
      
      // Additional validation to ensure date is not in the future
      if (birthDate > today) {
        errors.date_of_birth = 'Date of birth cannot be in the future.';
      }
    }

    const blood_group = String(formData.blood_group || '').toUpperCase();
    const validBloodGroups = /^(A|B|AB|O)[+-]$/;
    if (blood_group && !validBloodGroups.test(blood_group)) {
      errors.blood_group = 'Please enter a valid blood group (e.g., A+, O-, AB+).';
    }
    if (blood_group && blood_group.length > 5) {
      errors.blood_group = 'Blood Group must not exceed 5 characters.';
    }

    const designation = String(formData.designation || '');
    if (designation && /[0-9]/.test(designation)) {
      errors.designation = 'Designation should not contain numbers.';
    }
    if (designation && designation.length > 50) {
      errors.designation = 'Designation must not exceed 50 characters.';
    }

    const emergency_name_1 = String(formData.emergency_name_1 || '');
    if (emergency_name_1 && /[^a-zA-Z\s]/.test(emergency_name_1)) {
      errors.emergency_name_1 = 'Emergency name 1 should only contain alphabets and spaces.';
    }
    if (emergency_name_1 && emergency_name_1.length > 50) {
      errors.emergency_name_1 = 'Emergency Name 1 must not exceed 50 characters.';
    }

    const emergency_name_2 = String(formData.emergency_name_2 || '');
    if (emergency_name_2 && /[^a-zA-Z\s]/.test(emergency_name_2)) {
      errors.emergency_name_2 = 'Emergency name 2 should only contain alphabets and spaces.';
    }
    if (emergency_name_2 && emergency_name_2.length > 50) {
      errors.emergency_name_2 = 'Emergency Name 2 must not exceed 50 characters.';
    }

    const account_number = String(formData.account_number || '');
      if (account_number.includes(' ')) {
        errors.account_number = 'Account Number should not contain spaces.';
      } else if (!/^\d{9,18}$/.test(account_number)) {
        errors.account_number = 'Account Number must be 9 to 18 digits long and contain only numbers.';
    }

    if (
      formData.account_number &&
      formData.confirm_account_number &&
      formData.account_number !== formData.confirm_account_number
    ) {
      errors.confirm_account_number = 'Account number and confirm account number must match.';
    }

    const email = String(formData.email || '');
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = 'Please enter a valid email address.';
    }

    if (formData.contact_number) {
      const contact_number = String(formData.contact_number || '').trim();
      if (contact_number.length > 10) {
        errors.contact_number = 'Contact Number must not exceed 10 digits.';
      } else if (contact_number.length !== 10) {
        errors.contact_number = 'Contact number must be exactly 10 digits.';
      } else if (!/^\d+$/.test(contact_number)) {
        errors.contact_number = 'Contact Number must contain only numbers.';
      }
    }  

    if (formData.emergency_contact_1) {
      const emergency_contact_1 = String(formData.emergency_contact_1 || '').trim();
      if (emergency_contact_1.length > 10) {
        errors.emergency_contact_1 = 'Emergency Contact 1 must not exceed 10 digits.';
      } else if (emergency_contact_1.length !== 10) {
        errors.emergency_contact_1 = 'Emergency contact 1 must be exactly 10 digits.';
      } else if (!/^\d+$/.test(emergency_contact_1)) {
        errors.emergency_contact_1 = 'Emergency Contact 1 must contain only numbers.';
      }
    }  

    if (formData.emergency_contact_2) {
      const emergency_contact_2 = String(formData.emergency_contact_2 || '').trim();
      if (emergency_contact_2.length > 10) {
        errors.emergency_contact_2 = 'Emergency Contact 2 must not exceed 10 digits.';
      } else if (emergency_contact_2.length !== 10) {
        errors.emergency_contact_2 = 'Emergency contact 2 must be exactly 10 digits.';
      } else if (!/^\d+$/.test(emergency_contact_2)) {
        errors.emergency_contact_2 = 'Emergency Contact 2 must contain only numbers.';
      }
    }  

    // Ensure emergency contact numbers are not the same as contact number
    if (
      formData.emergency_contact_1 &&
      formData.emergency_contact_1 === formData.contact_number
    ) {
      errors.emergency_contact_1 = 'Emergency number cannot be the same as your contact number.';
    }

    if (
      formData.emergency_contact_2 &&
      formData.emergency_contact_2 === formData.contact_number
    ) {
      errors.emergency_contact_2 = 'Emergency number cannot be the same as your contact number.';
    }

    // Ensure emergency contact numbers are not the same as each other
    if (
      formData.emergency_contact_1 &&
      formData.emergency_contact_2 &&
      formData.emergency_contact_1 === formData.emergency_contact_2
    ) {
      errors.emergency_contact_2 = 'Emergency contact 2 cannot be the same as emergency contact 1.';
    }

    // Character length validations for addresses and relations
    const permanent_address = String(formData.permanent_address || '');
    if (permanent_address && permanent_address.length > 200) {
      errors.permanent_address = 'Permanent Address must not exceed 200 characters.';
    }

    const current_address = String(formData.current_address || '');
    if (current_address && current_address.length > 200) {
      errors.current_address = 'Current Address must not exceed 200 characters.';
    }

    const emergency_relation_1 = String(formData.emergency_relation_1 || '');
    if (emergency_relation_1 && emergency_relation_1.length > 30) {
      errors.emergency_relation_1 = 'Emergency Relation 1 must not exceed 30 characters.';
    }

    const emergency_relation_2 = String(formData.emergency_relation_2 || '');
    if (emergency_relation_2 && emergency_relation_2.length > 30) {
      errors.emergency_relation_2 = 'Emergency Relation 2 must not exceed 30 characters.';
    }

    const pan_number = String(formData.pan_number || '');
      const panCardRegex = /^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/;
      if (pan_number.includes(' ')) {
        errors.pan_number = 'PAN card should not contain spaces.';
      } else if (!panCardRegex.test(pan_number)) {
        errors.pan_number = 'PAN card should be in the format XXXXX1234X.';
    }


    const ifsc_code = String(formData.ifsc_code || '').trim();

    // Only letters and numbers allowed
    const alphanumericRegex = /^[A-Za-z0-9]+$/;

    // Check for at least one letter and one digit
    const hasLetter = /[A-Za-z]/.test(ifsc_code);
    const hasDigit = /\d/.test(ifsc_code);

    if (ifsc_code.includes(' ')) {
      errors.ifsc_code = 'IFSC code should not contain spaces.';
    } else if (!alphanumericRegex.test(ifsc_code)) {
      errors.ifsc_code = 'IFSC code should contain only letters and numbers.';
    } else if (!hasLetter || !hasDigit) {
      errors.ifsc_code = 'IFSC code must contain at least one letter and one number.';
    } else if (ifsc_code.length > 11) {
      errors.ifsc_code = 'IFSC code should be up to 11 characters long.';
    }


    requiredFiles.forEach(file => {
      if (!formData[file]) errors[file] = 'This file is required.';
    });
  
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  

  // Modify existing functions to handle new education level logic
  const validateStep2 = () => {
    const errors = {};
    let requiredFiles = [];
    const requiredFields = [
      'highest_qualification',
      'year_of_passing'
    ];

    const highest_qualification = String(formData.highest_qualification || '');
    if (!highest_qualification) {
      errors.highest_qualification = 'Please enter highest qualification.';
    }

    const year_of_passing = String(formData.year_of_passing || '');
    if (!year_of_passing) {
      errors.year_of_passing = 'Please enter year of passing.';
    } else {
      if (year_of_passing.length > 4) {
        errors.year_of_passing = 'Year of Passing must not exceed 4 digits.';
      } else if (!/^\d+$/.test(year_of_passing)) {
        errors.year_of_passing = 'Year of Passing must contain only numbers.';
      }
    }


    requiredFields.forEach(field => {
      if (!formData[field]?.trim()) errors[field] = 'This field is required.';
    });

    const level = formData.education_level;
    const isFresher = formData.employee_type === 'Fresher';

    // Dynamically determine required files based on education level
    switch (level) {
      case 'Non-HSC':
      case '10th':
        requiredFiles = ['marksheet_10th'];
        break;
      case '12th':
        requiredFiles = ['marksheet_10th', 'marksheet_12th'];
        break;
      case 'Graduate':
        requiredFiles = ['marksheet_10th', 'marksheet_12th', 'graduate_marksheet'];
        break;
      case 'Master':
        requiredFiles = ['marksheet_10th', 'marksheet_12th', 'graduate_marksheet', 'postgraduate_marksheet'];
        break;
      case 'Ph.D':
        requiredFiles = [
          'marksheet_10th', 
          'marksheet_12th', 
          'graduate_marksheet', 
          'postgraduate_marksheet', 
          'phd_marksheet',
        ];
        break;
      default:
        errors.education_level = 'Please select an education level.';
    }

    // Validate required files
    // requiredFiles.forEach(file => {
    //   if (!formData[file]) errors[file] = 'This file is required.';
    // });

    // Validate files
    requiredFiles.forEach((fileField) => {
      if (!formData[fileField]) {
        errors[fileField] = 'This file is required.';
      }
    });

    if (isFresher) {
      requiredFiles.push('leaving_certificate');
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateStep3 = () => {
    const errors = {};
    const requiredFields = [
                            'uan_number', 
                            'esic_number', 
                            'employee_type'
                          ];
    const requiredFiles = ['bank_proof'];
  
    requiredFields.forEach(field => {
      const value = formData[field]?.trim();
      if (!value) {
        errors[field] = 'This field is required.';
      } else {
        const isNA = /^NA$/i.test(value); // matches "na", "NA", "Na", etc.
        if (field === 'uan_number' && !isNA && !/^\d{12}$/.test(value)) {
          errors[field] = 'UAN number must be exactly 12 digits or NA.';
        }
        if (field === 'esic_number' && !isNA && !/^\d{10}$/.test(value)) {
          errors[field] = 'ESIC number must be exactly 10 digits or NA.';
        }
      }
    });
  
    requiredFiles.forEach(file => {
      if (!formData[file]) errors[file] = 'This file is required.';
    });
  
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  }; 
  
  const validateStep4 = () => {
    if (formData.employee_type === 'Fresher') return true; // Skip validation for freshers
  
    const errors = {};
    const requiredFiles = ['previous_offer_letter', 
                            'experience_letter', 
                            'salary_slip_1', 
                            'salary_slip_2', 
                            'salary_slip_3',
                            'previous_company_name',
                            'prev_designation',
                            'prev_hr_contact',
                            'prev_hr_email',
                            'prev_hr_name'];
  
    requiredFiles.forEach(file => {
      if (!formData[file]) errors[file] = 'This file is required.';
    });

    if (!formData.previous_company_name || formData.previous_company_name.trim() === '') {
      errors.previous_company_name = 'Previous company name is required.';
    }

    if (!formData.prev_designation || formData.prev_designation.trim() === '') {
      errors.prev_designation = 'Designation is required.';
    }

    if (!formData.prev_hr_name || formData.prev_hr_name.trim() === '') {
      errors.prev_hr_name = 'HR/Manager name is required.';
    }

    if (formData.prev_hr_contact) {
      const contact = formData.prev_hr_contact.trim();
      if (!/^\d{10}$/.test(contact)) {
        errors.prev_hr_contact = 'Contact number must be exactly 10 digits.';
      }
    } else {
      errors.prev_hr_contact = 'Contact number is required.';
    }

    const prev_hr_email = String(formData.prev_hr_email || '');
    if (prev_hr_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(prev_hr_email)) {
      errors.prev_hr_email = 'Please enter a valid email address.';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  
  const validateStep5 = () => {
    const errors = {};
    const requiredFields = ['followed_ibvl_social'];
  
    requiredFields.forEach(field => {
      if (!formData[field]?.trim()) errors[field] = 'This field is required.';
    });
  
    if (!formData.rating || formData.rating < 1) {
      errors.rating = 'Please provide a rating.';
    }
  
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  
  const handleNext = () => {
    let isValid = false;
  
    switch (currentStep) {
      case 1:
        isValid = validateStep1();
        break;
      case 2:
        isValid = validateStep2();
        break;
      case 3:
        isValid = validateStep3();
        break;
      case 4:
        isValid = validateStep4();
        break;
      case 5:
        isValid = validateStep5();
        break;
      default:
        isValid = true;
    }
  
    if (!isValid) return;
    
    // Skip Step 3 to 5 if if employee type is fresher
    if (currentStep === 3 && formData.employee_type === 'Fresher') {
      setCurrentStep(5);
    } else if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    } else {
      handleSubmit();
    }
  };

  // go back to the previous step
  const handleBack = () => {
    if (currentStep === 5 && formData.employee_type === 'Fresher') {
      setCurrentStep(3);
    } else if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  // clear form data
  const handleClear = () => {
    setFormData(initialState);
    setCurrentStep(1);
    setShowClearModal(false)
  };

  // submit form data to api
  const handleSubmit = async () => {
    // ALWAYS prioritize token from URL (backend requires it from URL)
    const tokenFromUrl = tokenFromPath || searchParams.get('token');
    const tokenToUse = tokenFromUrl || formData.onboarding_token;
    
    // Debug: Log token before submission
    console.log('Submission - Token check:', {
      tokenFromPath,
      queryToken: searchParams.get('token'),
      formDataToken: formData.onboarding_token,
      tokenToUse,
      isTokenValid,
      currentUrl: window.location.href
    });
    
    // CRITICAL: Backend requires token in URL parameter
    if (!tokenFromUrl?.trim()) {
      alert('Token is required in URL parameter. Please access this page using a URL with the token:\n\n• /on-boarding/your-token\n• /on-boarding?token=your-token\n\nCurrent URL: ' + window.location.href);
      setIsSubmitting(false);
      return;
    }
    
    // Validate that token exists and is valid before submission
    if (!tokenToUse?.trim()) {
      alert('Onboarding token is required. Please ensure the token is present in the URL.');
      setIsSubmitting(false);
      return;
    }

    if (!isTokenValid) {
      alert('Please validate your onboarding token before submitting the form.');
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true); 

    const payload = new FormData();
  
    // Append all fields to FormData
    // Always include onboarding_token even if empty (backend requires it)
    for (const key in formData) {
      if (formData[key] || key === 'onboarding_token') {
        if (key === "date_of_joining" || key === "date_of_birth") {
          const [year, month, day] = formData[key].split("-");
          const formattedDay = day.padStart(2, "0");
          const formattedMonth = month.padStart(2, "0");
          const formattedDate = `${formattedDay}/${formattedMonth}/${year}`; // dd/mm/yyyy
          payload.append(key, formattedDate);
        } else {
          // Use token from URL if available, otherwise use formData token
          const value = key === 'onboarding_token' ? tokenToUse : (formData[key] || '');
          payload.append(key, value);
        }
      }
    }

    // Ensure token is always in payload
    if (!payload.has('onboarding_token') || !payload.get('onboarding_token')) {
      payload.append('onboarding_token', tokenToUse);
    }

    console.log('Form Data - Token in payload:', payload.get('onboarding_token'));

    try {
      // Include token in URL as query parameter (backend might require it in URL)
      const apiUrl = tokenToUse
        ? `https://hrmspayroll.prepstripe.com/api/onboarding-form?onboarding_token=${encodeURIComponent(tokenToUse)}`
        : 'https://hrmspayroll.prepstripe.com/api/onboarding-form';
      
      console.log('API URL:', apiUrl);
      
      const response = await axios.post(
        apiUrl,
        payload, // your FormData object
        {
          // Axios handles headers automatically for FormData
          // Add Authorization header here if needed
          // headers: {
          //   // 'Authorization': `Bearer ${yourToken}`,
          // },
        }
      );
    
      if (response.status === 200 || response.status === 201) {
        setShowModal(true);    
        setFormErrors({});     
        setFormData(initialState); 
        setCurrentStep(1);          
        setFormErrors({});
      }
      // console.log('Server Response:', response.data);
    } catch (error) {
      // Check for token-related errors
      const errorMessage = error.response?.data?.message || error.response?.data?.user_message || '';
      const errorText = errorMessage.toLowerCase();
      
      if (errorText.includes('token') && (errorText.includes('required') || errorText.includes('url'))) {
        alert('Token is required in URL parameter. Please access this page with a valid token in the URL:\n\n• Path parameter: /on-boarding/your-token\n• Query parameter: /on-boarding?token=your-token\n\nIf you have a token, please refresh the page with the token in the URL.');
        setIsSubmitting(false);
        return;
      }

      if (error.response?.data?.errors) {
        const { message, errors } = error.response.data;
      
        // Alert the user for wrong inputs
        // alert("Wrong inputs. Go back in the form to see the error" || "Please check your inputs");
        // console.log("Submission failed:", error?.response?.data?.user_message, '-', error?.response?.data?.error_code);
        // alert("Submission failed:", error?.response?.data?.user_message, '-', error?.response?.data?.error_code || "Wrong inputs. Go back in the form to see the highlighted error");

        let userMessage, errorCode;

        if (error?.response?.data) {
          userMessage = error.response.data.user_message || message || "Unknown error occurred";
          errorCode = error.response.data.error_code;
        } else {
          userMessage = "Network error or no response from server";
          errorCode = null; // or leave undefined
        }

        alert(`Submission failed: ${userMessage}${errorCode ? " - " + errorCode : ""}`);


        // Define steps with corresponding fields
        const allSteps = {
          1: ['email', 'full_name', 'contact_number', 'date_of_birth', 'date_of_joining', 'designation', 'permanent_address', 'current_address', 'emergency_contact_1', 'emergency_contact_2', 'emergency_name_1', 'emergency_name_2', 'emergency_relation_1', 'emergency_relation_2', 'pan_number', 'aadhar_number', 'ifsc_code', 'blood_group', 'updated_cv', 'passport_photo', 'aadhar_card', 'pan_card', 'account_number', 'confirm_account_number'],
          2: ['highest_qualification', 'year_of_passing', 'marksheet_10th', 'marksheet_12th', 'graduate_marksheet', 'postgraduate_marksheet', 'phd_marksheet', 'other_qualifications', 'leaving_certificate'],
          3: ['uan_number', 'esic_number', 'employee_type', 'bank_proof'],
          4: ['previous_offer_letter', 'experience_letter', 'salary_slip_1', 'salary_slip_2', 'salary_slip_3', 'previous_company_name', 'prev_designation', 'prev_hr_contact', 'prev_hr_email', 'prev_hr_name'],
          // 5: ['nda', 'self_declaration', 'concern_form', 'code_of_conduct', 'background_verification', 'induction_acknowledgment', 'infosec_acknowledgment', 'posh_acknowledgment'],
          5: ['followed_ibvl_social', 'feedback'],
        };
      
        // Check which step has errors and navigate to it
        for (const step in allSteps) {
          if (allSteps[step].some(field => errors[field])) {
            setCurrentStep(parseInt(step)); // Update current step to show the correct one
            break;
          }
        }
      
        // Handle specific file type errors (e.g., invalid file format, missing files)
        const fileTypeErrors = ['updated_cv', 'passport_photo', 'aadhar_card', 'pan_card', 'marksheet_10th', 'marksheet_12th', 'graduate_marksheet', 'leaving_certificate', 'bank_proof', 'previous_offer_letter', 'experience_letter', 'salary_slips'];
      
        fileTypeErrors.forEach(file => {
          if (errors[file]) {
            // Check if the error is related to file type (you can customize the message if needed)
            if (errors[file].includes('Invalid file type') || errors[file].includes('File type is not allowed')) {
              alert(`${file} has an invalid file type. Please upload the correct file format.`);
            } else if (errors[file].includes('This file is required')) {
              alert(`${file} is missing. Please upload the required document.`);
            }
          }
        });
      
        // Set the form errors to display them to the user
        setFormErrors(errors);
      
      } else if (error.response?.data?.user_message) {

        let userMessage, errorCode;

        if (error?.response?.data) {
          userMessage = error.response.data.user_message || "Unknown error occurred";
          errorCode = error.response.data.error_code;
        } else {
          userMessage = "Network error or no response from server";
          errorCode = null; // or leave undefined
        }

        alert(`Submission failed: ${userMessage}${errorCode ? " - " + errorCode : ""}`);

        // If there's a general error message
        // console.error("Submission failed:", error?.response?.data?.user_message, '-', error?.response?.data?.error_code);
        // alert("Submission failed:", error?.response?.data?.user_message, '-', error?.response?.data?.error_code || "Check your inputs");
      
      } else {
        // Handle any other errors (e.g., network issues, etc.)
        let userMessage, errorCode;

        if (error?.response?.data) {
          userMessage = error.response.data.user_message || "Unknown error occurred";
          errorCode = error.response.data.error_code;
        } else {
          userMessage = "Network error or no response from server";
          errorCode = null; // or leave undefined
        }

        alert(`Submission failed: ${userMessage}${errorCode ? " - " + errorCode : ""}`);

        // alert("Submission failed:", error?.response?.data?.user_message, '-', error?.response?.data?.error_code);
      }
      
      } finally {
        // Set the submitting state to false after the error handling
        setIsSubmitting(false);
      }
  };

  const renderProgress = () => {
    const percent = (currentStep / totalSteps) * 100;
    return (
      <div className="w-52 bg-gray-200 h-2 rounded">
        <div
          className="h-full bg-[#56b1c7] rounded transition-all duration-300 ease-in-out"
          style={{ width: `${percent}%` }}
        />
      </div>
    );
  };

  const fileInputClass = "mt-1 block w-full text-sm text-gray-700 p-4 border rounded-lg bg-gray-50 border-gray-300 focus:ring-blue-500 focus:border-blue-500";

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="space-y-4">
            <label className="block">
              Personal Mail ID <span className='text-red-500'>*</span>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                readOnly={isTokenValid}
                className={`mt-1 block w-full border border-gray-300 rounded p-2 ${isTokenValid ? 'bg-gray-100 cursor-not-allowed' : ''}`}
              />
              {formErrors.email && <p className="text-red-500 text-sm">{formErrors.email}</p>}
            </label>
            <label className="block">
              Full Name as per Aadhar Card <span className='text-red-500'>*</span>
              <input
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                required
                readOnly={isTokenValid}
                className={`mt-1 block w-full border border-gray-300 rounded p-2 ${isTokenValid ? 'bg-gray-100 cursor-not-allowed' : ''}`}
              />
              {formErrors.full_name && <p className="text-red-500 text-sm">{formErrors.full_name}</p>}
            </label>
            <label className="block">
              Contact Number <span className='text-red-500'>*</span>
              <input
                name="contact_number"
                value={formData.contact_number}
                onChange={handleChange}
                required
                readOnly={isTokenValid}
                onKeyDown={(e) => {
                  if (e.key === ' ' || (!/[0-9]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key))) {
                    e.preventDefault();
                  }
                }}
                className={`mt-1 block w-full border border-gray-300 rounded p-2 ${isTokenValid ? 'bg-gray-100 cursor-not-allowed' : ''}`}
              />
              {formErrors.contact_number && <p className="text-red-500 text-sm">{formErrors.contact_number}</p>}
            </label>
            <label className="block">
              Date of Birth <span className='text-red-500'>*</span>
              <input
                type="date"
                name="date_of_birth"
                value={formData.date_of_birth}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.date_of_birth && <p className="text-red-500 text-sm">{formErrors.date_of_birth}</p>}
            </label>
            <label className="block">
              Date of Joining <span className='text-red-500'>*</span>
              <input
                type="date"
                name="date_of_joining"
                value={formData.date_of_joining}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.date_of_joining && <p className="text-red-500 text-sm">{formErrors.date_of_joining}</p>}
            </label>
            <label className="block">
              Designation as per offer letter <span className='text-red-500'>*</span>
              <input
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              <div className="text-sm text-gray-500 text-right">
                {formData.designation.length}/50 characters
              </div>
              {formErrors.designation && <p className="text-red-500 text-sm">{formErrors.designation}</p>}
            </label>
            {/* Temporary/Current Residential Address */}
            <label className="block">
              Temporary / Current Residential Address <span className="text-red-500">*</span>
              <textarea
                name="current_address"
                value={formData.current_address}
                onChange={(e) => {
                  const value = e.target.value;
                  setFormData((prevData) => ({
                    ...prevData,
                    current_address: value,
                    permanent_address: prevData.sameAsPermanent ? value : prevData.permanent_address,
                  }));
                }}
                required
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.current_address && (
                <p className="text-red-500 text-sm">{formErrors.current_address}</p>
              )}
            </label>
            {/* Same as above checkbox */}
            <div className="flex items-center mt-2 mb-4">
              <input
                type="checkbox"
                id="sameAsPermanent"
                checked={formData.sameAsPermanent || false}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setFormData((prevData) => ({
                    ...prevData,
                    sameAsPermanent: checked,
                    permanent_address: checked ? prevData.current_address : prevData.permanent_address,
                  }));
                }}
                className="mr-2"
              />
              <label htmlFor="sameAsPermanent" className="text-sm cursor-pointer">
                Same as above
              </label>
            </div>
            {/* Permanent Address */}
            <label className="block">
              Permanent Address as per the Aadhar Card <span className="text-red-500">*</span>
              <textarea
                name="permanent_address"
                value={formData.permanent_address}
                onChange={handleChange}
                required
                disabled={formData.sameAsPermanent}
                className="mt-1 block w-full border border-gray-300 rounded p-2 bg-white disabled:bg-gray-100"
              />
              {formErrors.permanent_address && (
                <p className="text-red-500 text-sm">{formErrors.permanent_address}</p>
              )}
            </label>
            {/* Emergency Contact Number 1 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <label className="block">
                Emergency Contact Number 1 <span className="text-red-500">*</span>
                <input
                  name="emergency_contact_1"
                  value={formData.emergency_contact_1}
                  onChange={handleChange}
                  required
                  onKeyDown={(e) => {
                    if (e.key === ' ' || (!/[0-9]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key))) {
                      e.preventDefault();
                    }
                  }}
                  className="mt-1 block w-full border border-gray-300 rounded p-2"
                />
                {formErrors.emergency_contact_1 && (
                  <p className="text-red-500 text-sm">{formErrors.emergency_contact_1}</p>
                )}
              </label>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Full Name */}
              <label className="block">
                Full Name 1 <span className="text-red-500">*</span>
                <input
                  name="emergency_name_1"
                  value={formData.emergency_name_1}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border border-gray-300 rounded p-2"
                />
                {formErrors.emergency_name_1 && (
                  <p className="text-red-500 text-sm">{formErrors.emergency_name_1}</p>
                )}
              </label>
              {/* Relation */}
              <label className="block">
                Relation <span className="text-red-500">*</span>
                <input
                  name="emergency_relation_1"
                  value={formData.emergency_relation_1}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border border-gray-300 rounded p-2"
                  placeholder={formData.emergency_name_1.trim() ? `Your relation to ${formData.emergency_name_1.trim()}?` : ''}
                />
                {formErrors.emergency_relation_1 && (
                  <p className="text-red-500 text-sm">{formErrors.emergency_relation_1}</p>
                )}
              </label>
            </div>
            {/* Emergency Contact Number 2 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <label className="block">
                Emergency Contact Number 2 <span className="text-red-500">*</span>
                <input
                  name="emergency_contact_2"
                  value={formData.emergency_contact_2}
                  onChange={handleChange}
                  required
                  onKeyDown={(e) => {
                    if (e.key === ' ' || (!/[0-9]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key))) {
                      e.preventDefault();
                    }
                  }}
                  className="mt-1 block w-full border border-gray-300 rounded p-2"
                />
                {formErrors.emergency_contact_2 && (
                  <p className="text-red-500 text-sm">{formErrors.emergency_contact_2}</p>
                )}
              </label>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Full Name 2 */}
              <label className="block">
                Full Name 2 <span className="text-red-500">*</span>
                <input
                  name="emergency_name_2"
                  value={formData.emergency_name_2}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border border-gray-300 rounded p-2"
                />
                {formErrors.emergency_name_2 && (
                  <p className="text-red-500 text-sm">{formErrors.emergency_name_2}</p>
                )}
              </label>

              {/* Relation 2 */}
              <label className="block">
                Relation <span className="text-red-500">*</span>
                <input
                  name="emergency_relation_2"
                  value={formData.emergency_relation_2}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border border-gray-300 rounded p-2"
                  placeholder={formData.emergency_name_2.trim() ? `Your relation to ${formData.emergency_name_2.trim()}?` : ''}
                />
                {formErrors.emergency_relation_2 && (
                  <p className="text-red-500 text-sm">{formErrors.emergency_relation_2}</p>
                )}
              </label>
            </div>
            <label className="block">
              Blood Group <span className='text-red-500'>*</span>
              <input
                name="blood_group"
                value={formData.blood_group}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.blood_group && <p className="text-red-500 text-sm">{formErrors.blood_group}</p>}
            </label>
            <label className="block">
              Updated CV <span className='text-red-500'>*</span>
              <input
                type="file"
                key={fileInputKeys.updated_cv}
                id="updated_cv"
                name="updated_cv"
                accept=".pdf,.jpeg,.jpg,.png"
                required
                // value={formData.updated_cv}
                onChange={handleFileChange}
                className={fileInputClass}
              />
              <small className='text-gray-500'>Upload 1 supported file. allowed file types (pdf, jpeg, jpg, png) Max 2 MB.</small>
              {formData.updated_cv && (
                <p className="text-sm text-green-600 mt-1">
                  Selected file: {formData.updated_cv.name}
                </p>
              )}
              {formErrors.updated_cv && <p className="text-red-500 text-sm">{formErrors.updated_cv}</p>}
            </label>
            <label className="block">
              Passport Size Photo (Please upload the recent high resolution photograph) <span className='text-red-500'>*</span>
              <input
                type="file"
                key={fileInputKeys.passport_photo}
                id="passport_photo"
                name="passport_photo"
                accept=".pdf,.jpeg,.jpg,.png"
                required
                // value={formData.passport_photo}
                onChange={handleFileChange}
                className={fileInputClass}
              />
              <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
              {formData.passport_photo && (
                <p className="text-sm text-green-600 mt-1">
                  Selected file: {formData.passport_photo.name}
                </p>
              )}
              {formErrors.passport_photo && <p className="text-red-500 text-sm">{formErrors.passport_photo}</p>}
            </label>
            <label className="block">
              Aadhar Card <span className='text-red-500'>*</span>
              <input
                type="file"
                key={fileInputKeys.aadhar_card}
                id="aadhar_card"
                name="aadhar_card"
                accept=".pdf,.jpeg,.jpg,.png"
                required
                // value={formData.aadhar_card}
                onChange={handleFileChange}
                className={fileInputClass}
              />
              <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
              {formData.aadhar_card && (
                <p className="text-sm text-green-600 mt-1">
                  Selected file: {formData.aadhar_card.name}
                </p>
              )}
              {formErrors.aadhar_card && <p className="text-red-500 text-sm">{formErrors.aadhar_card}</p>}
            </label>
            <label className="block">
              Aadhar Card Number <span className='text-red-500'>*</span>
              <input
                type="text"
                id="aadhar_number"
                name="aadhar_number"
                required
                value={formatAadharForDisplay(formData.aadhar_number)}
                onChange={(e) => {
                  // Get only the digits from the input
                  const digits = e.target.value.replace(/\D/g, '');
                  
                  // Limit to 12 digits max
                  const limitedDigits = digits.substring(0, 12);
                  
                  // Store only raw digits in form data
                  handleChange({
                    target: {
                      name: 'aadhar_number',
                      value: limitedDigits
                    }
                  });
                }}
                onKeyDown={(e) => {
                  if (e.key === ' ') {
                    e.preventDefault(); // Prevent typing space
                  }
                }}
                className={fileInputClass}
                placeholder="XXXX-XXXX-XXXX"
              />
              {formErrors.aadhar_number && <p className="text-red-500 text-sm">{formErrors.aadhar_number}</p>}
            </label>
            <label className="block">
              PAN Card <span className='text-red-500'>*</span>
              <input
                type="file"
                key={fileInputKeys.pan_card}
                id="pan_card"
                name="pan_card"
                accept=".pdf,.jpeg,.jpg,.png"
                required
                // value={formData.pan_card}
                onChange={handleFileChange}
                className={fileInputClass}
              />
              <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
              {formData.pan_card && (
                <p className="text-sm text-green-600 mt-1">
                  Selected file: {formData.pan_card.name}
                </p>
              )}
              {formErrors.pan_card && <p className="text-red-500 text-sm">{formErrors.pan_card}</p>}
            </label>
            <label className="block">
              Pan Card Number <span className='text-red-500'>*</span>
              <input
                type="text"
                id="pan_number"
                name="pan_number"
                required
                value={formData.pan_number}
                onChange={handleChange}
                onKeyDown={(e) => {
                  if (e.key === ' ') {
                    e.preventDefault(); // Prevent typing space
                  }
                }}
                className={`${fileInputClass} uppercase`}
              />
              {/* <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small> */}
              {formErrors.pan_number && <p className="text-red-500 text-sm">{formErrors.pan_number}</p>}
            </label>
            <label className="block">
              IFSC Code <span className="text-red-500">*</span>
              <input
                type="text"
                id="ifsc_code"
                name="ifsc_code"
                required
                value={formData.ifsc_code}
                onChange={handleChange}
                onKeyDown={(e) => {
                  if (e.key === ' ') {
                    e.preventDefault(); // Prevent typing space
                  }
                }}
                className={`${fileInputClass} uppercase`}
              />
              {formErrors.ifsc_code && (
                <p className="text-red-500 text-sm">{formErrors.ifsc_code}</p>
              )}
            </label>
            <label className="block">
              Account Number <span className='text-red-500'>*</span>
              <input
                type="text"
                id="account_number"
                name="account_number"
                required
                value={formData.account_number}
                onChange={handleChange}
                onKeyDown={(e) => {
                  if (e.key === ' ') {
                    e.preventDefault(); // Prevent typing space
                  }
                }}
                className={fileInputClass}
              />
              {/* <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small> */}
              {formErrors.account_number && <p className="text-red-500 text-sm">{formErrors.account_number}</p>}
            </label>
            <label className="block">
              Confirm Account Number <span className='text-red-500'>*</span>
              <input
                type="text"
                id="confirm_account_number"
                name="confirm_account_number"
                required
                value={formData.confirm_account_number}
                onChange={handleChange}
                onKeyDown={(e) => {
                  if (e.key === ' ') {
                    e.preventDefault(); // Prevent typing space
                  }
                }}
                onPaste={(e) => e.preventDefault()}
                onContextMenu={(e) => e.preventDefault()}
                className={fileInputClass}
              />
              {/* <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small> */}
              {formErrors.confirm_account_number && <p className="text-red-500 text-sm">{formErrors.confirm_account_number}</p>}
            </label>
          </div>
        );
      case 2:
        return (
          <div className="space-y-4">
            <label className="block">
              Highest Qualification <span className='text-red-500'>*</span>
              <input
                type="text"
                name="highest_qualification"
                value={formData.highest_qualification}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.highest_qualification && <p className="text-red-500 text-sm">{formErrors.highest_qualification}</p>}
            </label>

            <label className="block">
              Year of Passing <span className='text-red-500'>*</span>
              <input
                type="text"
                name="year_of_passing"
                value={formData.year_of_passing}
                onChange={handleChange}
                required
                onKeyDown={(e) => {
                  if (e.key === ' ' || (!/[0-9]/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key))) {
                    e.preventDefault();
                  }
                }}
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.year_of_passing && <p className="text-red-500 text-sm">{formErrors.year_of_passing}</p>}
            </label>

            <label className="block">
              Highest Educational Qualification <span className='text-red-500'>*</span>
              <select
                name="education_level"
                value={formData.education_level}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              >
              <option value="">Select Education Qualification</option>
              <option value="10th">10th</option>
              <option value="12th">12th</option>
              <option value="Graduate">Graduate</option>
              <option value="Master">Master/PG</option>
              <option value="Ph.D">Ph.D</option>
              </select>
              {formErrors.education_level && <p className="text-red-500 text-sm">{formErrors.education_level}</p>}
            </label>
            
            {/* 10th Marksheet - shown for only 10th*/}
            {['10th'].includes(formData.education_level) && (
              <label className="block">
                10th Marksheet <span className='text-red-500'>*</span>
                <input 
                  type="file" 
                  key={fileInputKeys.marksheet_10th}
                  id="marksheet_10th"
                  name="marksheet_10th" 
                  accept=".pdf,.jpeg,.jpg,.png"
                  onChange={handleFileChange} 
                  required 
                  className={fileInputClass} />
                <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                {formData.marksheet_10th && (
                  <p className="text-sm text-green-600 mt-1">
                    Selected file: {formData.marksheet_10th.name}
                  </p>
                )}
                {formErrors.marksheet_10th && <p className="text-red-500 text-sm">{formErrors.marksheet_10th}</p>}
              </label>
            )}

            {/* 10th, 12th Marksheet - shown for 12th */}
            {['12th'].includes(formData.education_level) && (
              <>
                <label className="block">
                  10th Marksheet <span className='text-red-500'>*</span>
                  <input 
                    type="file" 
                    key={fileInputKeys.marksheet_10th}
                    id="marksheet_10th"
                    name="marksheet_10th" 
                    accept=".pdf,.jpeg,.jpg,.png"
                    onChange={handleFileChange} 
                    required 
                    className={fileInputClass} />
                  <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                  {formData.marksheet_10th && (
                    <p className="text-sm text-green-600 mt-1">
                      Selected file: {formData.marksheet_10th.name}
                    </p>
                  )}
                  {formErrors.marksheet_10th && <p className="text-red-500 text-sm">{formErrors.marksheet_10th}</p>}
                </label>
                <label className="block">
                12th Marksheet <span className='text-red-500'>*</span>
                <input 
                  type="file" 
                  key={fileInputKeys.marksheet_12th}
                  id="marksheet_12th"
                  name="marksheet_12th" 
                  accept=".pdf,.jpeg,.jpg,.png"
                  onChange={handleFileChange} 
                  required 
                  className={fileInputClass} />
                <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                {formData.marksheet_12th && (
                  <p className="text-sm text-green-600 mt-1">
                    Selected file: {formData.marksheet_12th.name}
                  </p>
                )}
                {formErrors.marksheet_12th && <p className="text-red-500 text-sm">{formErrors.marksheet_12th}</p>}
              </label>
              </>
            )}

            {/* 10th, 12th, graduation Marksheet - shown for graduate */}
            {['Graduate'].includes(formData.education_level) && (
              <>
                <label className="block">
                  10th Marksheet <span className='text-red-500'>*</span>
                  <input 
                    type="file" 
                    key={fileInputKeys.marksheet_10th}
                    id="marksheet_10th"
                    name="marksheet_10th" 
                    accept=".pdf,.jpeg,.jpg,.png"
                    onChange={handleFileChange} 
                    required 
                    className={fileInputClass} />
                  <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                  {formData.marksheet_10th && (
                    <p className="text-sm text-green-600 mt-1">
                      Selected file: {formData.marksheet_10th.name}
                    </p>
                  )}
                  {formErrors.marksheet_10th && <p className="text-red-500 text-sm">{formErrors.marksheet_10th}</p>}
                </label>
                <label className="block">
                12th Marksheet <span className='text-red-500'>*</span>
                <input 
                  type="file" 
                  key={fileInputKeys.marksheet_12th}
                  id="marksheet_12th"
                  name="marksheet_12th" 
                  accept=".pdf,.jpeg,.jpg,.png"
                  onChange={handleFileChange} 
                  required 
                  className={fileInputClass} />
                <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                {formData.marksheet_12th && (
                  <p className="text-sm text-green-600 mt-1">
                    Selected file: {formData.marksheet_12th.name}
                  </p>
                )}
                {formErrors.marksheet_12th && <p className="text-red-500 text-sm">{formErrors.marksheet_12th}</p>}
                </label>
                <label className="block">
                  Graduation Marksheet <span className='text-red-500'>*</span>
                  <input 
                    type="file" 
                    key={fileInputKeys.graduate_marksheet}
                    id="graduate_marksheet"
                    name="graduate_marksheet" 
                    accept=".pdf,.jpeg,.jpg,.png"
                    onChange={handleFileChange} 
                    required 
                    className={fileInputClass} />
                  <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                  {formData.graduate_marksheet && (
                    <p className="text-sm text-green-600 mt-1">
                      Selected file: {formData.graduate_marksheet.name}
                    </p>
                  )}
                  {formErrors.graduate_marksheet && <p className="text-red-500 text-sm">{formErrors.graduate_marksheet}</p>}
                </label>
              </>
            )}

            {/* 10th, 12th, graduation Marksheet - shown for graduate */}
            {['Master'].includes(formData.education_level) && (
              <>
                <label className="block">
                  10th Marksheet <span className='text-red-500'>*</span>
                  <input 
                    type="file" 
                    key={fileInputKeys.marksheet_10th}
                    id="marksheet_10th"
                    name="marksheet_10th" 
                    accept=".pdf,.jpeg,.jpg,.png"
                    onChange={handleFileChange} 
                    required 
                    className={fileInputClass} />
                  <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                  {formData.marksheet_10th && (
                    <p className="text-sm text-green-600 mt-1">
                      Selected file: {formData.marksheet_10th.name}
                    </p>
                  )}
                  {formErrors.marksheet_10th && <p className="text-red-500 text-sm">{formErrors.marksheet_10th}</p>}
                </label>
                <label className="block">
                12th Marksheet <span className='text-red-500'>*</span>
                <input 
                  type="file" 
                  key={fileInputKeys.marksheet_12th}
                  id="marksheet_12th"
                  name="marksheet_12th" 
                  accept=".pdf,.jpeg,.jpg,.png"
                  onChange={handleFileChange} 
                  required 
                  className={fileInputClass} />
                <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                {formData.marksheet_12th && (
                  <p className="text-sm text-green-600 mt-1">
                    Selected file: {formData.marksheet_12th.name}
                  </p>
                )}
                {formErrors.marksheet_12th && <p className="text-red-500 text-sm">{formErrors.marksheet_12th}</p>}
                </label>
                <label className="block">
                  Graduation Marksheet <span className='text-red-500'>*</span>
                  <input 
                    type="file" 
                    key={fileInputKeys.graduate_marksheet}
                    id="graduate_marksheet"
                    name="graduate_marksheet" 
                    accept=".pdf,.jpeg,.jpg,.png"
                    onChange={handleFileChange} 
                    required 
                    className={fileInputClass} />
                  <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                  {formData.graduate_marksheet && (
                    <p className="text-sm text-green-600 mt-1">
                      Selected file: {formData.graduate_marksheet.name}
                    </p>
                  )}
                  {formErrors.graduate_marksheet && <p className="text-red-500 text-sm">{formErrors.graduate_marksheet}</p>}
                </label>
                <label className="block">
                  Postgraduation Marksheet <span className='text-red-500'>*</span>
                  <input 
                    type="file" 
                    key={fileInputKeys.postgraduate_marksheet}
                    id="postgraduate_marksheet"
                    name="postgraduate_marksheet" 
                    accept=".pdf,.jpeg,.jpg,.png"
                    onChange={handleFileChange} 
                    required 
                    className={fileInputClass} />
                  <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                  {formData.postgraduate_marksheet && (
                    <p className="text-sm text-green-600 mt-1">
                      Selected file: {formData.postgraduate_marksheet.name}
                    </p>
                  )}
                  {formErrors.postgraduate_marksheet && <p className="text-red-500 text-sm">{formErrors.postgraduate_marksheet}</p>}
                </label>
              </>
            )}

            {/* 10th, 12th, graduation marksheet, postgraduation/masters marksheep, phd marksheet */}
            {['Ph.D'].includes(formData.education_level) && (
              <>
                <label className="block">
                  10th Marksheet <span className='text-red-500'>*</span>
                  <input 
                    type="file" 
                    key={fileInputKeys.marksheet_10th}
                    id="marksheet_10th"
                    name="marksheet_10th" 
                    accept=".pdf,.jpeg,.jpg,.png"
                    onChange={handleFileChange} 
                    required 
                    className={fileInputClass} />
                  <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                  {formData.marksheet_10th && (
                    <p className="text-sm text-green-600 mt-1">
                      Selected file: {formData.marksheet_10th.name}
                    </p>
                  )}
                  {formErrors.marksheet_10th && <p className="text-red-500 text-sm">{formErrors.marksheet_10th}</p>}
                </label>
                <label className="block">
                12th Marksheet <span className='text-red-500'>*</span>
                <input 
                  type="file" 
                  key={fileInputKeys.marksheet_12th}
                  id="marksheet_12th"
                  name="marksheet_12th" 
                  accept=".pdf,.jpeg,.jpg,.png"
                  onChange={handleFileChange} 
                  required 
                  className={fileInputClass} />
                <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                {formData.marksheet_12th && (
                  <p className="text-sm text-green-600 mt-1">
                    Selected file: {formData.marksheet_12th.name}
                  </p>
                )}
                {formErrors.marksheet_12th && <p className="text-red-500 text-sm">{formErrors.marksheet_12th}</p>}
                </label>
                <label className="block">
                  Graduation Marksheet <span className='text-red-500'>*</span>
                  <input 
                    type="file" 
                    key={fileInputKeys.graduate_marksheet}
                    id="graduate_marksheet"
                    name="graduate_marksheet" 
                    accept=".pdf,.jpeg,.jpg,.png"
                    onChange={handleFileChange} 
                    required 
                    className={fileInputClass} />
                  <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                  {formData.graduate_marksheet && (
                    <p className="text-sm text-green-600 mt-1">
                      Selected file: {formData.graduate_marksheet.name}
                    </p>
                  )}
                  {formErrors.graduate_marksheet && <p className="text-red-500 text-sm">{formErrors.graduate_marksheet}</p>}
                </label>
                <label className="block">
                  Postgraduation Marksheet <span className='text-red-500'>*</span>
                  <input 
                    type="file" 
                    key={fileInputKeys.postgraduate_marksheet}
                    id="postgraduate_marksheet"
                    name="postgraduate_marksheet" 
                    accept=".pdf,.jpeg,.jpg,.png"
                    onChange={handleFileChange} 
                    required 
                    className={fileInputClass} />
                  <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                  {formData.postgraduate_marksheet && (
                    <p className="text-sm text-green-600 mt-1">
                      Selected file: {formData.postgraduate_marksheet.name}
                    </p>
                  )}
                  {formErrors.postgraduate_marksheet && <p className="text-red-500 text-sm">{formErrors.postgraduate_marksheet}</p>}
                </label>
                <label className="block">
                  Ph.D Marksheet <span className='text-red-500'>*</span>
                  <input 
                    type="file" 
                    key={fileInputKeys.phd_marksheet}
                    id="phd_marksheet"
                    name="phd_marksheet" 
                    accept=".pdf,.jpeg,.jpg,.png"
                    onChange={handleFileChange} 
                    required 
                    className={fileInputClass} />
                  <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
                  {formData.phd_marksheet && (
                    <p className="text-sm text-green-600 mt-1">
                      Selected file: {formData.phd_marksheet.name}
                    </p>
                  )}
                  {formErrors.phd_marksheet && <p className="text-red-500 text-sm">{formErrors.phd_marksheet}</p>}
                </label>
              </>
            )}

            {/* Other Qualifications - always shown  */}
            <label className="block">
              Other Qualification
              <input 
                type="file" 
                key={fileInputKeys.other_qualifications}
                id="other_qualifications"
                name="other_qualifications" 
                accept=".pdf,.jpeg,.jpg,.png"
                onChange={handleFileChange} 
                required 
                className={fileInputClass} />
              <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
              {formData.other_qualifications && (
                <p className="text-sm text-green-600 mt-1">
                  Selected file: {formData.other_qualifications.name}
                </p>
              )}
              {formErrors.other_qualifications && <p className="text-red-500 text-sm">{formErrors.other_qualifications}</p>}
            </label>

            {/* Leaving Certificate - always shown */}
            <label className="block">
              LC/Birth Certificate (Mandatory if Fresher) <span className='text-red-500'>*</span>
              <input 
                type="file" 
                key={fileInputKeys.leaving_certificate}
                id="leaving_certificate"
                name="leaving_certificate" 
                accept=".pdf,.jpeg,.jpg,.png"
                onChange={handleFileChange} 
                required 
                className={fileInputClass} />
              <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
              {formData.leaving_certificate && (
                <p className="text-sm text-green-600 mt-1">
                  Selected file: {formData.leaving_certificate.name}
                </p>
              )}
              {formErrors.leaving_certificate && <p className="text-red-500 text-sm">{formErrors.leaving_certificate}</p>}
            </label>
          </div>
        );
      case 3:
        return (
          <div className="space-y-4">
            <label className="block">
              Cancelled Cheque OR Passbook <span className='text-red-500'>*</span>
              <input 
                type="file" 
                key={fileInputKeys.bank_proof}
                id="bank_proof"
                name="bank_proof" 
                accept=".pdf,.jpeg,.jpg,.png"
                onChange={handleFileChange} 
                required 
                className={fileInputClass} />
              <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
              {formData.bank_proof && (
                <p className="text-sm text-green-600 mt-1">
                  Selected file: {formData.bank_proof.name}
                </p>
              )}
              {formErrors.bank_proof && <p className="text-red-500 text-sm">{formErrors.bank_proof}</p>}
            </label>
            <label className="block">
              UAN Number (Please mention <span classsName="font-bold">NA</span> if not registered previously with any employer)
              <input
                name="uan_number"
                value={formData.uan_number}
                onChange={handleChange}
                min={0}
                max={10}
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.uan_number && <p className="text-red-500 text-sm">{formErrors.uan_number}</p>}
            </label>
            <label className="block">
              ESIC Number (Please mention <span classsName="font-bold">NA</span> if not registered previously with any employer)
              <input
                name="esic_number"
                value={formData.esic_number}
                onChange={handleChange}
                min={0}
                max={12}
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.esic_number && <p className="text-red-500 text-sm">{formErrors.esic_number}</p>}
            </label>

            <label className="block">
              You are joining as: <span className='text-red-500'>*</span>
              <select
                name="employee_type"
                value={formData.employee_type}
                onChange={handleChange}
                required
                className="mt-1 block w-52 border border-gray-300 rounded p-2"
              >
                <option value="">Select...</option>
                <option value="Fresher">Fresher/Intern</option>
                <option value="Experienced">Experienced</option>
              </select>
              {formErrors.employee_type && <p className="text-red-500 text-sm">{formErrors.employee_type}</p>}
            </label>
          </div>
        );
      case 4:
        return (
          <div className="space-y-4">
            {/* <h3 className="text-xl font-semibold">Page 4: Previous Employment (Full Time Only)</h3> */}
            <label className="block">
              Previous Company's Offer Letter <span className='text-red-500'>*</span>
              <input 
                type="file" 
                key={fileInputKeys.previous_offer_letter}
                id="previous_offer_letter"
                name="previous_offer_letter" 
                accept=".pdf,.jpeg,.jpg,.png"
                onChange={handleFileChange} 
                className={fileInputClass} />
              <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
              {formData.previous_offer_letter && (
                <p className="text-sm text-green-600 mt-1">
                  Selected file: {formData.previous_offer_letter.name}
                </p>
              )}
              {formErrors.previous_offer_letter && <p className="text-red-500 text-sm">{formErrors.previous_offer_letter}</p>}
            </label>
            <label className="block">
              Experience Letter or Relieving Letter <span className='text-red-500'>*</span>
              <input 
                type="file" 
                key={fileInputKeys.experience_letter}
                id="experience_letter"
                name="experience_letter" 
                accept=".pdf,.jpeg,.jpg,.png"
                onChange={handleFileChange} 
                className={fileInputClass}  />
              <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
              {formData.experience_letter && (
                <p className="text-sm text-green-600 mt-1">
                  Selected file: {formData.experience_letter.name}
                </p>
              )}
              {formErrors.experience_letter && <p className="text-red-500 text-sm">{formErrors.experience_letter}</p>}
            </label>

            <div className="flex items-center my-4">
              <hr className="flex-grow border-t border-gray-300" />
              <span className="mx-4 text-gray-600 text-sm">
                Select last three months salary slips one by one.
              </span>
              <hr className="flex-grow border-t border-gray-300" />
            </div>

            <label className="block">
              Salary Slip 1 <span className='text-red-500'>*</span>
              <div className="space-y-2 mt-1">
                <input 
                  type="file" 
                  key={fileInputKeys.salary_slip_1}
                  id="salary_slip_1"
                  name="salary_slip_1" 
                  accept=".pdf,.jpeg,.jpg,.png"
                  onChange={handleFileChange} 
                  className={fileInputClass} />
              </div>
              <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
              {formData.salary_slip_1 && (
                <p className="text-sm text-green-600 mt-1">
                  Selected file: {formData.salary_slip_1.name}
                </p>
              )}
              {formErrors.salary_slip_1 && <p className="text-red-500 text-sm">{formErrors.salary_slip_1}</p>}
            </label>
            <label className="block">
              Salary Slip 2 <span className='text-red-500'>*</span>
              <div className="space-y-2 mt-1">
                <input 
                  type="file" 
                  key={fileInputKeys.salary_slip_2}
                  id="salary_slip_2"
                  name="salary_slip_2" 
                  accept=".pdf,.jpeg,.jpg,.png"
                  onChange={handleFileChange} 
                  className={fileInputClass} />
              </div>
              <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
              {formData.salary_slip_2 && (
                <p className="text-sm text-green-600 mt-1">
                  Selected file: {formData.salary_slip_2.name}
                </p>
              )}
              {formErrors.salary_slip_2 && <p className="text-red-500 text-sm">{formErrors.salary_slip_2}</p>}
            </label>
            <label className="block">
              Salary Slip 3 <span className='text-red-500'>*</span>
              <div className="space-y-2 mt-1">
                <input 
                  type="file" 
                  key={fileInputKeys.salary_slip_3}
                  id="salary_slip_3"
                  name="salary_slip_3" 
                  accept=".pdf,.jpeg,.jpg,.png"
                  onChange={handleFileChange} 
                  className={fileInputClass} />
              </div>
              <small className='text-gray-500'>Upload 1 supported file. allowed types (pdf, jpeg, jpg, png) Max 2 MB.</small>
              {formData.salary_slip_3 && (
                <p className="text-sm text-green-600 mt-1">
                  Selected file: {formData.salary_slip_3.name}
                </p>
              )}
              {formErrors.salary_slip_3 && <p className="text-red-500 text-sm">{formErrors.salary_slip_3}</p>}
            </label>

            <div className="flex items-center my-4">
              <hr className="flex-grow border-t border-gray-300" />
              <span className="mx-4 text-gray-600 text-sm">
                Background verification
              </span>
              <hr className="flex-grow border-t border-gray-300" />
            </div>

            {/* prev company name */}
            <label className="block">
              Company Name <span className='text-red-500'>*</span>
              <input
                name="previous_company_name"
                value={formData.previous_company_name}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.previous_company_name && <p className="text-red-500 text-sm">{formErrors.previous_company_name}</p>}
            </label>

            {/* prev company employee id */}
            <label className="block">
              Employee ID 
              <input
                name="prev_emp_id"
                value={formData.prev_emp_id}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.prev_emp_id && <p className="text-red-500 text-sm">{formErrors.prev_emp_id}</p>}
            </label>
            
            {/* designation */}
            <label className="block">
              Designation <span className='text-red-500'>*</span>
              <input
                name="prev_designation"
                value={formData.prev_designation}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.prev_designation && <p className="text-red-500 text-sm">{formErrors.prev_designation}</p>}
            </label>

            <label className="block">
              Previous HR Email ID <span className='text-red-500'>*</span>
              <input
                type="email"
                name="prev_hr_email"
                value={formData.prev_hr_email}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.prev_hr_email && <p className="text-red-500 text-sm">{formErrors.prev_hr_email}</p>}
            </label>

            <label className="block">
              HR Name <span className='text-red-500'>*</span>
              <input
                name="prev_hr_name"
                value={formData.prev_hr_name}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.prev_hr_name && <p className="text-red-500 text-sm">{formErrors.prev_hr_name}</p>}
            </label>

            <label className="block">
              HR Contact Number <span className='text-red-500'>*</span>
              <input
                type="text"
                name="prev_hr_contact"
                value={formData.prev_hr_contact}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              {formErrors.prev_hr_contact && <p className="text-red-500 text-sm">{formErrors.prev_hr_contact}</p>}
            </label>
          </div>
        );
      case 5:
        return (
          <div className="space-y-4">
            {/* <h3 className="text-xl font-semibold">Page 5: Final Feedback & Welcome</h3> */}
            <p>Hope you have visited and followed the below social presence of IBVL!!</p>
            <ul className="list-disc list-inside">
              <li>Website: <a href="https://www.theimperative.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline hover:underline-offset-4">www.theimperative.in</a></li>
              <li>LinkedIn: <a href="https://in.linkedin.com/company/imperative-business-ventures-limited" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline hover:underline-offset-4">imperativebusiness</a></li>
              <li>Instagram: <a href="https://www.instagram.com/imperativebusiness/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline hover:underline-offset-4">imperativebusiness</a></li>
              <li>Twitter / X: <a href="https://x.com/imperativebiz" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline hover:underline-offset-4">imperativebiz</a></li>
            </ul>
            <label className="block">
              Have you followed us on social?
              <select
                name="followed_ibvl_social"
                value={formData.followed_ibvl_social}
                onChange={handleChange}
                className="mt-1 block w-52 border border-gray-300 rounded p-2"
              >
                <option value="">Select...</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
              {formErrors.followed_ibvl_social && <p className="text-red-500 text-sm">{formErrors.followed_ibvl_social}</p>}
            </label>
            <label className="block my-4">
              Any note/feedback/query before joining Team IBVL
              <textarea
                name="feedback"
                value={formData.feedback}
                onChange={handleChange}
                maxLength={200} // Set your desired character limit here
                className="mt-1 block w-full border border-gray-300 rounded p-2"
              />
              <div className="text-sm text-gray-500 text-right">
                {formData.feedback.length}/200 characters
              </div>
              {formErrors.feedback && (
                <p className="text-red-500 text-sm">{formErrors.feedback}</p>
              )}
            </label>
            <div className='mt-4'>
              <label className='mt-4'>
                Please rate this onboarding form: <span className='text-red-500'>*</span> <br />
                <p>Thank you for your cooperation and Welcome to Team Imperative!</p>
                <div className='text-center py-4'>
                  <div className="flex justify-center space-x-4">
                    {[1, 2, 3, 4, 5].map((n) => (
                      <div key={n} className="flex flex-col items-center">
                        <span className="text-sm font-semibold">{n}</span>
                        <span
                          onClick={() => setFormData({ ...formData, rating: n })}
                          style={{ cursor: 'pointer', fontSize: '24px' }}
                        >
                          {n <= formData.rating ? '❤️' : '🤍'}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                {formErrors.rating && (
                  <p className="text-red-500 text-sm">{formErrors.rating}</p>
                )}
              </label>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className='bg-[#d3e5e8] min-h-screen py-2'>
      <div className="mt-2 mb-4 flex justify-center">
        <img
          src={Image}
          alt="Logo"
          className="h-24 w-72 object-contain rounded-[10px]"
        />
      </div>
      <div className="max-w-3xl mx-auto p-4 border my-2 bg-white rounded-xl border-t-8 border-[#5098a2] border-r-none border-l-none border-b-none">
        <h2 className="text-center text-3xl font-extralight tracking-wider mb-4">On-boarding  - IBVL Employee </h2>
        <hr></hr>
        <div className='flex flex-col gap-1'>
          <p className='my-2'>This form is designed to facilitate a paper less smooth employee on-boarding process.
          </p>
          <hr/>
          <small className='p-2'><span className='text-red-500'>*</span> Indicates required question</small>
        </div>
        <hr></hr>
        <div className='flex flex-col justify-center items-center mt-5 gap-2'>
          {renderProgress()} <span>Page {currentStep} of {totalSteps}</span>
        </div>
        {/* <p className="mb-4">Page {currentStep} of {totalSteps}</p> */}
        {/* {renderProgress()} */}
        
        {/* Onboarding Token Field */}
        <div className="mt-4 mb-4">
          <label className="block">
            Onboarding Token <span className='text-red-500'>*</span>
            <div className="flex items-center gap-2">
              <input
                type="text"
                name="onboarding_token"
                value={formData.onboarding_token}
                onChange={handleChange}
                onBlur={validateOnboardingToken}
                required
                readOnly={!!(tokenFromPath || searchParams.get('token'))}
                className={`mt-1 block w-full border border-gray-300 rounded p-2 ${
                  (tokenFromPath || searchParams.get('token')) 
                    ? 'bg-gray-100 cursor-not-allowed' 
                    : ''
                }`}
                placeholder="Enter your onboarding token"
              />
              {tokenValidationStatus === 'validating' && (
                <div className="mt-1">
                  <svg className="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </div>
              )}
              {tokenValidationStatus === 'valid' && (
                <div className="mt-1">
                  <svg className="h-5 w-5 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </div>
            {tokenValidationStatus === 'error' && tokenErrorMessage && (
              <p className="text-red-500 text-sm mt-1">{tokenErrorMessage}</p>
            )}
          </label>
        </div>
        
        <form className="space-y-4 mt-4">
          {renderStep()}
          <div className="flex items-center  gap-2 justify-between mt-4">
            <div className='flex items-center'>
              <button
                type="button"
                onClick={handleBack}
                disabled={currentStep === 1 || !isTokenValid}
                className={`px-4 py-2 text-lg bg-transparent ${currentStep === 1 || !isTokenValid ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500'} ${!isTokenValid ? '' : 'hover:bg-gray-100'} font-bold rounded`}
              >
                Back
              </button>
              <button
                type="button"
                onClick={handleNext}
                disabled={!isTokenValid}
                className={`px-4 py-2 text-lg bg-transparent ${!isTokenValid ? 'text-gray-300 cursor-not-allowed' : 'text-[#0d8a95]'} ${!isTokenValid ? '' : 'hover:bg-gray-100'} font-bold rounded`}
              >
                {/* {currentStep === totalSteps ? 'Submit' : 'Next'} */}
                {isSubmitting
                  ? "Submitting..."
                  : currentStep === totalSteps
                  ? "Submit"
                  : "Next"}
              </button>
            </div>

            <div className='flex items-center gap-2'>
              <button
                type="button"
                onClick={() => setShowSummaryModal(true)}
                disabled={!isTokenValid}
                className={`px-4 py-2 text-lg bg-transparent ${!isTokenValid ? 'text-gray-300 cursor-not-allowed' : 'text-[#0d8a95]'} ${!isTokenValid ? '' : 'hover:bg-gray-100'} font-bold rounded`}
              >
                Summary
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* after submission modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1001]">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full text-center">
            <h2 className="text-xl font-semibold mb-4">🎉 Response Submitted!</h2>
            <p className="mb-4">Thank you for submitting the onboarding form.</p>
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* after clear button clicked */}
      {showClearModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1001]">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full text-center">
            <h2 className="md:text-xl text-md font-semibold mb-4">Are you sure you want to reset the form?</h2>
            <div className='flex justify-center items-center gap-2'>
              <button
                className="bg-blue-500 text-white px-8 py-2 rounded hover:bg-blue-600"
                onClick={handleClear}
              >
                Yes
              </button>
              <button
                className="bg-gray-500 text-white px-8 py-2 rounded hover:bg-gray-600"
                onClick={() => setShowClearModal(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Summary Modal */}
      {showSummaryModal && renderSummaryModal()}
    </div>
  );
};

export default EmployeeOnboardingForm;
